import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import img from "../Assets/service7.jpg";
import monika from '../Assets/Smonik.png'
import { Helmet } from "react-helmet";

function BlogDetail2() {
  return (
    <>
    <Helmet>
  <title>Causes of Female Infertility & When to See a Doctor | Delhi IVF Expert</title>

  <meta
    name="description"
    content="Learn the common causes of infertility in women like PCOS, hormonal imbalance & age factors. Dr. Monika Gupta, IVF specialist in Delhi, explains when to seek fertility treatment."
  />

  <meta
    name="keywords"
    content="female infertility causes, infertility treatment Delhi, PCOS infertility, hormonal imbalance fertility, when to see fertility doctor, IVF specialist Delhi, women fertility problems"
  />

  
  <meta property="og:title" content="Common Causes of Infertility in Women" />
  <meta property="og:description" content="Understand female infertility causes and when to consult a fertility specialist." />
  <meta property="og:type" content="article" />

  <meta name="robots" content="index, follow" />
</Helmet>
      <Navbar />

      <div className="blog-detail-page">

        {/* Banner */}
        <div className="banner-page">
          <h3> Common Causes of Infertility in Women and When to Seek Help</h3>
          <p>Home / Blog / Fertility Health</p>
        </div>

        {/* Blog Hero */}
      

        {/* Blog Content */}
        <div className="container1 blog-detail-wrapper">

          <div className="blog-content">

            <img src={img} alt="blog" className="blog-main-image" />

            <div className="blog-meta">
              <span><i className="bi bi-calendar-date"></i> March 2026</span>
              <span> Dr. Monika Gupta</span>
            </div>

            <p>
              Infertility is a common concern that affects many women and couples
              worldwide. It occurs when a woman is unable to conceive after
              trying for a significant period of time. Various medical,
              hormonal, and lifestyle-related factors can affect fertility.
              Understanding these causes is the first step toward effective
              treatment and improving the chances of pregnancy.
            </p>

            <p>
              With the help of modern reproductive medicine and advanced
              fertility treatments, many women can successfully overcome
              infertility challenges. Early diagnosis and consultation with
              a fertility specialist can make a significant difference.
            </p>

            <h2>Common Causes of Infertility in Women</h2>

            <p>
              Several conditions can affect a woman’s reproductive health and
              make it difficult to conceive. Some of the most common causes
              include hormonal disorders, ovulation problems, and structural
              issues in the reproductive system.
            </p>

            <ul className="blog-list">
              <li>Polycystic Ovary Syndrome (PCOS)</li>
              <li>Blocked or damaged fallopian tubes</li>
              <li>Hormonal imbalance affecting ovulation</li>
              <li>Endometriosis</li>
              <li>Age-related decline in egg quality</li>
              <li>Unhealthy lifestyle factors such as stress or poor diet</li>
            </ul>

            <div className="blog-quote">
              “Early diagnosis and proper fertility care can greatly increase
              the chances of successful conception and help couples achieve
              their dream of parenthood.”
            </div>

            <h2>How Age Affects Fertility</h2>

            <p>
              Age plays an important role in fertility. As women grow older,
              the quantity and quality of eggs gradually decrease. Women
              above the age of 35 may experience reduced fertility and may
              take longer to conceive naturally.
            </p>

            <p>
              Fortunately, advancements in reproductive technology such as
              IVF and fertility preservation techniques provide new
              opportunities for women to achieve pregnancy even at later
              stages of life.
            </p>

            <h2>When Should You Seek Medical Help?</h2>

            <p>
              Couples should consider consulting a fertility specialist if
              they have been trying to conceive for more than one year without
              success. For women above the age of 35, medical consultation is
              recommended after six months of trying.
            </p>

            <p>
              A fertility specialist can perform necessary tests to identify
              the underlying cause and recommend the most suitable treatment
              options, helping couples move closer to their goal of starting
              a family.
            </p>

          </div>

        </div>

        {/* Author */}
       <section className="blog-author">
          <div className="container1 author-wrapper">

            <img
              src={monika}
              alt="doctor"
              className="author-image"
            />

            <div>
              <h3>Dr. Monika Gupta</h3>
              <p>
               Senior IVF & Fertility Specialist with 15+ years of experience in reproductive medicine and women's healthcare. Dedicated to providing expert fertility care.
              </p>
            </div>

          </div>
        </section>

      </div>

      <Footer />
    </>
  );
}

export default BlogDetail2;